module.exports = __webpack_public_path__ + "media/honey-icons/icon-away-674dacc6.svg";